import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable} from "rxjs";
import {shareReplay} from "rxjs/operators";

import {UserRequestType, UserSearchParamsType} from "@pages/home/get-user-request.types";

@Injectable({
  providedIn: 'root'
})
export class SearchParamsService {
  private _searchParams$: BehaviorSubject<UserRequestType>
  public searchParams$: Observable<UserRequestType>
  //public resetList$: Observable<boolean>

  public initialSearchParams: any = {
    region: '',
    agefrom: 0,
    ageto: 0,
    sexpreef: '',
    meritalstat: '',
    userNick: '',
    age_h:'',
    age_l:'',
    gender:''
  };
  public initialSearch: UserRequestType = {
    action: 'online',
    filter: 'lastActivity',
    resultsPerPage: 20,
    page: 1,
    list: '',
    searchparams: this.initialSearchParams
  };

  constructor() {
    this._searchParams$ = new BehaviorSubject<UserRequestType>(this.initialSearch)
    this.searchParams$ = this._searchParams$.asObservable().pipe(shareReplay(1));
  }

  resetParams() {
    this._searchParams$.next(this.initialSearch);
  }

  setParams(params: any) {
    this._searchParams$.next({...this.initialSearch, ...params});
  }

  updateParams(params: Partial<any>) {
    this._searchParams$.next({...this._searchParams$.value, ...params})
  }

}
